<template>
<div class="chapter">
<div class="inner_page">
<div id="Prologue">
<p class="fm-title"><a id="page_7">Prologue</a></p><a id="page_7">
<p class="h1">‘I go forth into battle, light of heart’</p>
<p class="noindent1">In June 1940, Bill Millington sat down to write the hardest letter of his life. ‘My dear parents …’ But how to go on? With an invasion expected at any time and his new friends flying regular sorties to France, it would not be long before the 22-year-old joined them on operations. He had no fear of dying. ‘I go forth into battle, light of heart.’ He acknowledged that he might not survive combat and wanted to salve the grief of those he loved in case he failed to return.</p>
<p class="para">Bill was penning a ‘last letter’ to his parents, to be delivered only in the event of his death. He wanted to give them a sense of his passion for flying, which ‘meant more to me than just a career or means of livelihood’, his joy in the ‘companionship of men and boys with similar interests, the intoxication of speed, the rush of air and the pulsating beat of the motor [which] awakes some answering chord deep down which is indescribable’. He wanted to tell them of his commitment to defending the land of his birth. And he wanted to assure them that ‘since leaving home I have endeavoured to live up to those standards dictated by honour and chivalry’ which they and he held so dear, ‘and am sure that I have not failed you’. He accepted that he might die in battle but had no regrets. ‘I would not have it otherwise.’</p>
</a><p class="para"><a id="page_7">There was no more to say. After signing it ‘Farewell, your loving son, Bill’, he folded the page, slipped it into an envelope and addressed it to his mother. He wrote firmly on the top left-hand corner, ‘To be forwarded in the event of fatal accident’.<sup></sup></a><span href="#/xhtml/32_Notes#fn1-pro" id="ft1-pro" title="Link target outside of Sample">1</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Prologue.vue?ac4e6e2c